<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
        </ul>
      </nav>
      <div class="copyright">
        &copy; coded with
        <i class="fa fa-heart heart"></i> by
        <a href="https://ederit.com" target="_blank">ederit.com</a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {}

</script>
<style>

</style>
